"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var cache_persist_1 = require("@wora/cache-persist");
var netinfo_1 = require("@wora/netinfo");
var isServer = typeof window === 'undefined';
var defaultOfflineOptions = {
    manualExecution: false,
    start: function (_mutations) { return Promise.resolve(_mutations); },
    finish: function (_mutations, _error) { return Promise.resolve(undefined); },
    onExecute: function (mutation) { return Promise.resolve(mutation); },
    onComplete: function (_options) { return Promise.resolve(true); },
    onDiscard: function (_options) { return Promise.resolve(true); },
    compare: function (v1, v2) { return v1.fetchTime - v2.fetchTime; },
    onPublish: function (offlineRecord) { return Promise.resolve(offlineRecord); },
    execute: function (_offlineRecord) { return Promise.reject(new Error('set execute offline options')); },
};
var OfflineFirst = (function () {
    function OfflineFirst(persistOptions) {
        if (persistOptions === void 0) { persistOptions = {}; }
        this.offlineOptions = defaultOfflineOptions;
        this.online = isServer;
        this.rehydrated = isServer;
        var persistOptionsStoreOffline = tslib_1.__assign({ prefix: 'offline-first', serialize: true }, persistOptions);
        this.offlineStore = new cache_persist_1.Cache(persistOptionsStoreOffline);
        if (this.rehydrated) {
            this.promisesRestore = Promise.resolve(true);
        }
    }
    OfflineFirst.prototype.setOfflineOptions = function (offlineOptions) {
        this.offlineOptions = tslib_1.__assign(tslib_1.__assign({}, defaultOfflineOptions), offlineOptions);
    };
    OfflineFirst.prototype.purge = function () {
        var _this = this;
        this.offlineStore.purge();
        return this.offlineStore.flush().then(function () {
            _this.notify();
            return true;
        });
    };
    OfflineFirst.prototype.isManualExecution = function () {
        var manualExecution = this.offlineOptions.manualExecution;
        return manualExecution;
    };
    OfflineFirst.prototype.dispose = function () {
        this.disposeListener && this.disposeListener();
        this.promisesRestore = null;
        this.rehydrated = false;
    };
    OfflineFirst.prototype.hydrate = function () {
        var _this = this;
        if (!this.promisesRestore) {
            this.promisesRestore = Promise.all([netinfo_1.NetInfo.fetch(), this.offlineStore.restore()])
                .then(function (result) {
                var finalize = function () {
                    _this.disposeListener = netinfo_1.NetInfo.addEventListener(function (state) {
                        var isConnected = state.isConnected;
                        if (_this.online !== isConnected && isConnected && !_this.isManualExecution()) {
                            _this.process();
                        }
                        _this.online = isConnected;
                    });
                    _this.notify();
                    _this.rehydrated = true;
                    return true;
                };
                var isConnected = result[0].isConnected;
                _this.online = isConnected;
                if (isConnected && !_this.isManualExecution()) {
                    return _this.process().then(finalize);
                }
                return finalize();
            })
                .catch(function (error) {
                _this.rehydrated = false;
                _this.promisesRestore = null;
                throw error;
            });
        }
        return this.promisesRestore;
    };
    OfflineFirst.prototype.isOnline = function () {
        return this.online;
    };
    OfflineFirst.prototype.subscribe = function (callback) {
        return this.offlineStore.subscribe(callback);
    };
    OfflineFirst.prototype.notify = function () {
        var compare = this.offlineOptions.compare;
        this.offlineStore.notify({ state: Object.values(this.getState()).sort(compare) });
    };
    OfflineFirst.prototype.getState = function () {
        return this.offlineStore.getState();
    };
    OfflineFirst.prototype.remove = function (id) {
        var _this = this;
        this.offlineStore.remove(id);
        return this.offlineStore.flush().then(function () { return _this.notify(); });
    };
    OfflineFirst.prototype.set = function (id, value) {
        var _this = this;
        this.offlineStore.set(id, value);
        return this.offlineStore.flush().then(function () { return _this.notify(); });
    };
    OfflineFirst.prototype.getListMutation = function () {
        var compare = this.offlineOptions.compare;
        var requests = Object.assign({}, this.getState());
        return Object.values(requests).sort(compare);
    };
    OfflineFirst.prototype.process = function () {
        var _this = this;
        if (!this.busy) {
            var _a = this.offlineOptions, start = _a.start, finish_1 = _a.finish, onExecute_1 = _a.onExecute;
            var listMutation = this.getListMutation();
            var parallelPromises_1 = [];
            this.busy = start(listMutation).then(function (startMutations) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _loop_1, this_1, _i, startMutations_1, mutation, error_1;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 7, 8, 9]);
                            _loop_1 = function (mutation) {
                                var processMutation;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, onExecute_1(mutation)];
                                        case 1:
                                            processMutation = _a.sent();
                                            if (!processMutation) return [3, 4];
                                            if (!!processMutation.serial) return [3, 2];
                                            parallelPromises_1.push(this_1.executeMutation(processMutation));
                                            return [3, 4];
                                        case 2: return [4, Promise.all(parallelPromises_1)
                                                .then(function () { return _this.executeMutation(processMutation); })
                                                .catch(function (error) {
                                                throw error;
                                            })];
                                        case 3:
                                            _a.sent();
                                            parallelPromises_1 = [];
                                            _a.label = 4;
                                        case 4: return [2];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, startMutations_1 = startMutations;
                            _a.label = 1;
                        case 1:
                            if (!(_i < startMutations_1.length)) return [3, 4];
                            mutation = startMutations_1[_i];
                            return [5, _loop_1(mutation)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            _i++;
                            return [3, 1];
                        case 4:
                            if (!(parallelPromises_1.length > 0)) return [3, 6];
                            return [4, Promise.all(parallelPromises_1)];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6: return [2, finish_1(this.getListMutation())];
                        case 7:
                            error_1 = _a.sent();
                            return [2, finish_1(this.getListMutation(), error_1)];
                        case 8:
                            this.busy = undefined;
                            return [7];
                        case 9: return [2];
                    }
                });
            }); });
        }
        return this.busy;
    };
    OfflineFirst.prototype.executeMutation = function (offlineRecord) {
        var _this = this;
        var _a = this.offlineOptions, execute = _a.execute, onComplete = _a.onComplete, onDiscard = _a.onDiscard;
        var id = offlineRecord.id;
        offlineRecord.error = undefined;
        offlineRecord.retry = offlineRecord.retry ? offlineRecord.retry + 1 : 0;
        return this.set(id, tslib_1.__assign({}, offlineRecord)).then(function () {
            return execute(offlineRecord)
                .then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    offlineRecord.error = undefined;
                    return [2, onComplete({ offlineRecord: offlineRecord, response: response }).then(function (complete) {
                            if (complete) {
                                return _this.remove(id);
                            }
                            return _this.set(id, tslib_1.__assign({}, offlineRecord));
                        })];
                });
            }); })
                .catch(function (error) {
                offlineRecord.error = error;
                return onDiscard({ offlineRecord: offlineRecord, error: error }).then(function (discard) {
                    if (discard) {
                        return _this.remove(id);
                    }
                    return _this.set(id, tslib_1.__assign({}, offlineRecord));
                });
            });
        });
    };
    OfflineFirst.prototype.publish = function (options) {
        var _this = this;
        var onPublish = this.offlineOptions.onPublish;
        var id = options.id ? options.id : "" + this.offlineStore.getAllKeys().length;
        var request = options.request, serial = options.serial;
        var fetchTime = Date.now();
        return onPublish({ id: id, request: request, fetchTime: fetchTime, serial: serial }).then(function (offlineRecord) {
            return _this.set(offlineRecord.id, offlineRecord)
                .then(function () { return offlineRecord; })
                .catch(function (error) {
                throw error;
            });
        });
    };
    return OfflineFirst;
}());
exports.OfflineFirst = OfflineFirst;
//# sourceMappingURL=index.js.map